import React from "react";
import Head from "next/head";
import PropTypes from "prop-types";

function HfnSeo(props) {
  const { metaTitle, metaDescription, metaImage } = props;

  const {
    data: {
      attributes: { url: metaImageUrl },
    },
  } = metaImage;

  return (
    <Head>
      <title>{metaTitle || "Test"} </title>
      <meta name="description" content={metaDescription} />
      <link rel="icon" href={metaImageUrl} sizes="32x32" />
      <link rel="preconnect" href="https://fonts.gstatic.com" />
      <link rel="preconnect" href="https://fonts.googleapis.com" />
    </Head>
  );
}

// Specifies the default values for props:
HfnSeo.defaultProps = {
  metaTitle: "Heartfulness",
  metaDescription:
    "Heartfulness Is an Educational , Volunteer-Based Non-Profit Organization, Focused on Meditation, Relaxation, Yoga & Spirituality.",
  metaImage: PropTypes.shape({
    data: PropTypes.shape({
      attributes: PropTypes.shape({
        name: "Heartfulness",
        url: "https://cdn-web.heartfulness.org/en/wp-content/uploads/2021/02/cropped-hfn-flower-logo-32x32.png",
        alternativeText: "Heartfulness-icon",
        height: 32,
        width: 32,
      }),
    }),
  }),
};

HfnSeo.propTypes = {
  metaTitle: PropTypes.string,
  metaDescription: PropTypes.string,
  metaImage: PropTypes.shape({
    data: PropTypes.shape({
      attributes: PropTypes.shape({
        name: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        alternativeText: PropTypes.string.isRequired,
        height: PropTypes.number.isRequired,
        width: PropTypes.number.isRequired,
      }),
    }),
  }),
};

export default HfnSeo;
